import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideo2"><Path d="M2.5 5.5L17.5 5.50002V18.5H2.5V5.5Z" stroke="currentColor"/><Path d="M17.5 8.5L22.5 6.5V17.5L17.5 15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
